module.exports = __webpack_public_path__ + "img/Lesotho.cbb2048f.gif";